export interface Product {
  id: string
  name: string
  description: string
  price: number
  category: 'packs' | 'cortes' | 'extras'
  image: string
  popular?: boolean
}

export const products: Product[] = [
  // Packs
  {
    id: 'pack-1',
    name: 'Experiencia Single',
    description:
      'Perfecto para uno. Incluye 300g de Picanha, Chorizo Artesanal y papas nativas.',
    price: 18.5,
    category: 'packs',
    // Raw picanha cut
    image:
      'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'pack-2',
    name: 'Dúo Parrillero',
    description:
      'Cena romántica o para compartir. Tomahawk (800g), 2 Chorizos, vegetales asados y chimichurri de la casa.',
    price: 45.0,
    category: 'packs',
    // Raw tomahawk steak
    image:
      'https://images.unsplash.com/photo-1615937657715-bc7b4b7962c1?auto=format&fit=crop&q=80&w=800',
    popular: true,
  },
  {
    id: 'pack-3',
    name: 'Festín Quiteño',
    description:
      'Para 4-6 personas. Costillar entero, Picanha, 6 Chorizos, Morcillas y selección de salsas.',
    price: 85.0,
    category: 'packs',
    // Raw ribs
    image:
      'https://images.unsplash.com/photo-1529193591184-b1d580690dd0?auto=format&fit=crop&q=80&w=800',
  },

  // Cortes Individuales
  {
    id: 'corte-1',
    name: 'Tomahawk Premium',
    description:
      'Corte espectacular con hueso largo, marmoleo intenso. Aprox 1kg.',
    price: 32.0,
    category: 'cortes',
    // Raw tomahawk with bone
    image:
      'https://images.unsplash.com/photo-1603048297172-c92544798d5e?auto=format&fit=crop&q=80&w=1400',
  },
  {
    id: 'corte-2',
    name: 'Picanha Angus',
    description:
      'La reina de la parrilla. Tapa de cuadril con capa de grasa perfecta.',
    price: 24.5,
    category: 'cortes',
    // Raw picanha/sirloin cap
    image:
      'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&q=80&w=1400',
  },
  {
    id: 'corte-3',
    name: 'Bife de Chorizo',
    description: 'Corte clásico argentino, tierno y jugoso. 400g.',
    price: 16.0,
    category: 'cortes',
    // Raw striploin/NY strip
    image:
      'https://images.unsplash.com/photo-1551135049-8a33b5883817?auto=format&fit=crop&q=80&w=1400',
  },
  {
    id: 'corte-4',
    name: 'Costillas St. Louis',
    description:
      'Costillar de cerdo carnoso, ideal para ahumar o parrilla lenta.',
    price: 22.0,
    category: 'cortes',
    // Raw pork ribs
    image:
      'https://images.unsplash.com/photo-1529193591184-b1d580690dd0?auto=format&fit=crop&q=80&w=1400',
  },

  // Extras
  {
    id: 'extra-1',
    name: 'Carbón de Quebracho',
    description: 'Bolsa de 5kg. Encendido rápido y larga duración.',
    price: 6.5,
    category: 'extras',
    image:
      'https://images.unsplash.com/photo-1542351967-d5ae722fed71?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'extra-2',
    name: 'Sal Parrillera Ahumada',
    description: 'Frasco 200g. Sal marina con toques de humo natural.',
    price: 5.0,
    category: 'extras',
    image:
      'https://images.unsplash.com/photo-1626139576127-45229600722e?auto=format&fit=crop&q=80&w=800',
  },
  {
    id: 'extra-3',
    name: 'Chimichurri Artesanal',
    description: 'Nuestra receta secreta. 250ml.',
    price: 4.5,
    category: 'extras',
    image:
      'https://images.unsplash.com/photo-1599940824399-b87987ce0799?auto=format&fit=crop&q=80&w=800',
  },
]
